export default __webpack_public_path__ + "static/media/Leads.315bbd01.svg";